import styled from "styled-components";

export const Container = styled.div`
  font-family: "Poppins", sans-serif;
  display: flex;
  max-height: 335px;
`;

export const ContainerLeft = styled.div`
  flex: 3 auto;
  padding-top: 10px;
`;

export const ContainerRight = styled.div`
  flex: 1 auto;
  border-left: 0.9px solid #AFAFAF;
  padding-left: 25px;
  overflow: auto;
`;
